import React from "react";
import clsx from "clsx";

export const Card = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  return <div className={clsx("border border-solid border-foreground", className)} {...props} />;
};

export const CardContent = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  return <div className={clsx("p-4", className)} {...props} />;
};